__turbopack_context__.v({
  "className": "dosis_65fd9bd1-module__hiOlLW__className",
  "variable": "dosis_65fd9bd1-module__hiOlLW__variable",
});
